import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import EmployeeDashboard from "./Dashboard";
import EmployeeToday from "./Today";

/**
 * Decides which landing page to show at `/employe`.
 * - Mobile (< 768px) OR PWA in standalone display-mode  -> Today
 * - Desktop / tablet browser                            -> Dashboard
 * The choice is re-evaluated on window resize / display-mode change so that
 * rotating a tablet or opening the PWA behaves as expected.
 */
function pickTargetIsMobile() {
  if (typeof window === "undefined") return false;
  const narrow = window.matchMedia("(max-width: 767px)").matches;
  const standalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true; // iOS Safari
  return narrow || standalone;
}

export default function EmployeeHome() {
  const [isMobile, setIsMobile] = useState(pickTargetIsMobile);

  useEffect(() => {
    const mqNarrow = window.matchMedia("(max-width: 767px)");
    const mqStandalone = window.matchMedia("(display-mode: standalone)");
    const update = () => setIsMobile(pickTargetIsMobile());
    mqNarrow.addEventListener?.("change", update);
    mqStandalone.addEventListener?.("change", update);
    return () => {
      mqNarrow.removeEventListener?.("change", update);
      mqStandalone.removeEventListener?.("change", update);
    };
  }, []);

  // Use Navigate so the URL reflects the actual view (bookmarking works,
  // and the sidebar highlights the correct entry).
  if (isMobile) return <Navigate to="/employe/aujourdhui" replace />;
  return <EmployeeDashboard />;
}
